import { render, staticRenderFns } from "./ClubContainer.vue?vue&type=template&id=4c8a7f70&"
import script from "./ClubContainer.vue?vue&type=script&lang=js&"
export * from "./ClubContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports